const { get } = require("network/http/api");

export const getShopProductCategoryByCompanyId = companyId => {
  return get(`/product/category/${companyId}`);
};
